export enum BuildingType {
  SOLID = 'SOLID',
  NOT_SOLID = 'NOT_SOLID',
}

export const getHouseholdBuildingTypeLabel = (value: BuildingType): string => {
  switch (value) {
    case BuildingType.SOLID:
      return $localize`Batiment solide`;
    case BuildingType.NOT_SOLID:
      return $localize`Batiment non solide`;
    default:
      return '';
  }
};

export enum HouseType {
  SINGLE_FAMILY = 'SINGLE_FAMILY',
  MULTI_FAMILY = 'MULTI_FAMILY',
}

export const getHouseTypeLabel = (value: HouseType): string => {
  switch (value) {
    case HouseType.SINGLE_FAMILY:
      return $localize`Maison à une famille`;
    case HouseType.MULTI_FAMILY:
      return $localize`Maison à plusieurs famille`;
    default:
      return '';
  }
};

export enum HouseholdAdditionalCovers {
  VEHICLE = 'VEHICLE',
  GROSS_NEGLIGENCE = 'GROSS_NEGLIGENCE',
  HORSE = 'HORSE',
  HUNTER = 'HUNTER',
}

export const getHouseholdAdditionalCoverLabel = (
  value: HouseholdAdditionalCovers
): string => {
  switch (value) {
    case HouseholdAdditionalCovers.VEHICLE:
      return $localize`Véhicule de tiers`;
    case HouseholdAdditionalCovers.GROSS_NEGLIGENCE:
      return $localize`Renonciation à la faute grave`;
    case HouseholdAdditionalCovers.HORSE:
      return $localize`Location de chevaux`;
    case HouseholdAdditionalCovers.HUNTER:
      return $localize`Chasseur`;
    default:
      return '';
  }
};

export enum HouseholdCovers {
  ROBBERY = 'ROBBERY',
  OUTSIDE_ROBBERY = 'OUTSIDE_ROBBERY',
  HEARTHQUAKE = 'HEARTHQUAKE',
  WATER_DAMAGE = 'WATER_DAMAGE',
  NATURAL_EVENTS = 'NATURAL_EVENTS',
  GLASS_BREAKAGE = 'GLASS_BREAKAGE',
  ELECTRONIC_DEVICES = 'ELECTRONIC_DEVICES',
  OUTDOOR_EQUIPMENT = 'OUTDOOR_EQUIPMENT',
}

export const getHouseholdCoversLabel = (value: HouseholdCovers): string => {
  switch (value) {
    case HouseholdCovers.ROBBERY:
      return $localize`Vol`;
    case HouseholdCovers.NATURAL_EVENTS:
      return $localize`Incendie/évènements naturels`;
    case HouseholdCovers.OUTSIDE_ROBBERY:
      return $localize`Vol simple à l'extérieur du domicile`;
    case HouseholdCovers.HEARTHQUAKE:
      return $localize`Tremblement de terre`;
    case HouseholdCovers.WATER_DAMAGE:
      return $localize`Dégâts des eaux`;
    case HouseholdCovers.GLASS_BREAKAGE:
      return $localize`Bris de glace`;
    case HouseholdCovers.OUTDOOR_EQUIPMENT:
      return $localize`Aménagement extérieur mobiles`;
    case HouseholdCovers.ELECTRONIC_DEVICES:
      return $localize`Casco ménage`;
    default:
      return '';
  }
};

export enum HouseHoldLiability {
  INDIVIDUAL = 'INDIVIDUAL',
  SEVERAL_INDIVIDUALS = 'SEVERAL_INDIVIDUALS',
  NONE = 'NONE',
}

export const getHouseholdLiabilityLabel = (
  value: HouseHoldLiability
): string => {
  switch (value) {
    case HouseHoldLiability.INDIVIDUAL:
      return $localize`Individuel`;
    case HouseHoldLiability.SEVERAL_INDIVIDUALS:
      return $localize`Famille`;
    case HouseHoldLiability.NONE:
      return $localize`Aucune`;
    default:
      return '';
  }
};

export enum OwnershipConditionsEnum {
  TENANT = 'TENANT',
  HOUSE_OWNER = 'HOUSE_OWNER',
  FLOOR_OWNER = 'FLOOR_OWNER',
}

export const getOwnershipConditionLabel = (
  value: OwnershipConditionsEnum
): string => {
  switch (value) {
    case OwnershipConditionsEnum.TENANT:
      return $localize`Locataire`;
    case OwnershipConditionsEnum.HOUSE_OWNER:
      return $localize`Propriétaire d'une maison`;
    case OwnershipConditionsEnum.FLOOR_OWNER:
      return $localize`Propriétaire d'un étage`;
    default:
      return '';
  }
};
